"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImagemFeedback = require("./ImagemFeedback");

Object.keys(_ImagemFeedback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ImagemFeedback[key];
    }
  });
});